/**
 * @file dispatchAnswerSingle.ts
 * Exports a method to add a submitted answer to the answers within AppState.
 */
import { prop, omit } from 'ramda';
import type { AppState } from '../types';

/**
 * Helper method that returns a filterd answer if Q3 or Scope 3 emission option is No.
 *
 * @param {AppState} appState
 *   The application state before applying actions.
 */
export default (appState: AppState) => {
  const submitted = prop('submitted')(appState);

  return omit(['Q5', 'Q6'], submitted);
};
